import { Box, Card, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
const FeatureCards = () => {
  const { t } = useTranslation();
  const cards = [
    {
      id: 1,
      image: "/images/Frame 15.png",
      title: t("customizedCakesTitle"),
      description: t("customizedCakesDescription"),
    },
    {
      id: 2,
      image: "/images/Frame 18.png",
      title: t("birthdayCakesTitle"),
      description: t("birthdayCakesDescription"),
    },
    {
      id: 3,
      image: "/images/Frame 17.png",
      title: t("occasionCakesTitle"),
      description: t("occasionCakesDescription"),
    },
    {
      id: 4,
      image: "/images/Frame 16.png",
      title: t("limitedEditionTitle"),
      description: t("limitedEditionDescription"),
    },
  ];
  return (
    <Box
      sx={{
        maxWidth: 1200,
        mx: "auto",
        px: 2,
        display: "grid",
        gap: 3,
        gridTemplateColumns: {
          xs: "1fr",
          sm: "1fr 1fr",
          md: "repeat(4, 1fr)",
        },
      }}
    >
      {cards.map((card) => (
        <Card
          key={card.id}
          elevation={0}
          sx={{
            borderRadius: "28px",
            background:
              "linear-gradient(180deg, #FFFFFF 0%, #FFF7FA 100%)",
            border: "1px solid #F2E6EB",
            p: 3,
          }}
        >
          {/* Image */}
          <Box
            sx={{
              height: 220,
              mb: 3,
              borderRadius: "18px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              background:
                "radial-gradient(circle at center, #FFF6EB 0%, #FFFFFF 70%)",
            }}
          >
            <Box
              component="img"
              src={card.image}
              alt={card.title}
              sx={{
                maxWidth: 180,
                maxHeight: 180,
                objectFit: "contain",
              }}
            />
          </Box>

          {/* Title */}
          <Typography
            sx={{
              fontFamily: "Inter, sans-serif !important",
              fontWeight: 500,
              fontSize: "18px",
              color: "#5A5A6F",
              mb: 1,
            }}
          >
            {/* {card.title} */}
          </Typography>

          {/* Description */}
          <Typography
            sx={{
              fontFamily: "Inter, sans-serif !important",
              fontSize: "16px",
              lineHeight: "24px",
              color: "#1A1A1A",
            }}
          >
            {card.description}
          </Typography>
        </Card>
      ))}
    </Box>
  );
};

export default FeatureCards;
